module.exports = __webpack_public_path__ + "static/img/Nine of Swords.97b6439.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Nine of Swords.jpg
// module id = 1285
// module chunks = 0